import React from "react";
import { Modal, Button } from "react-bootstrap";

// Shared destructive-action confirm. Defaults keep the original "Deactivation"
// wording used by users / entities / sites; callers with a different verb
// (e.g. deprovisioning an organisation) pass `title` / `actionLabel` / `busy`.
const DeleteConfirmation = ({
  showModal,
  hideModal,
  confirmModal,
  deletename,
  message,
  title = "Deactivation Confirmation",
  actionLabel = "Deactivate",
  icon = "assets/img/deactivate.png",
  busy = false,
}) => {
  return (
    <Modal show={showModal} onHide={hideModal} centered className="custom-modal-width-delete">
      <Modal.Header>
        {/* <Modal.Title style={{ fontSize: '16px' }}>Deactivation Confirmation</Modal.Title> */}
      </Modal.Header>
      <Modal.Body>
        <div
          className=""
          style={{ wordWrap: "break-word", padding: "22px", fontSize: "15px", textAlign: "center" }}
        >
          <img
            src={icon}
            alt=""
            style={{ width: "55px", height: "55px", marginBottom: "10px" }}
          />
          <h4 style={{ color: "#CC2229", fontSize: "20px" }}>{title}</h4>
          {message}
        </div>
      </Modal.Body>
      <Modal.Footer className="delete-modal-buttons">
        <Button className="btn-cancel outline-btn" variant="default" onClick={hideModal} disabled={busy}>
          Cancel
        </Button>
        <Button variant="danger" className="btn-deactive" onClick={() => confirmModal(deletename)} disabled={busy}>
          {busy ? `${actionLabel}…` : actionLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmation;
